import getEnv from '@settings/getEnv';
import { loggerFactory } from '@settings/services/logger';
import axios from 'axios';

import {
  FreeLocalizationServiceInterface,
  LoadWidgetLocalizationParams,
  LoadWidgetLocalizationResponse,
} from './interface';

class FreeLocalizationService implements FreeLocalizationServiceInterface {
  private readonly logger = loggerFactory().make(`FreeLocalizationService`);
  private readonly freeLocalizationEndpoint: string;

  constructor() {
    const { REACT_APP_FREE_LOCALIZATION_ENDPOINT } = getEnv();

    this.freeLocalizationEndpoint = REACT_APP_FREE_LOCALIZATION_ENDPOINT;
  }

  async LoadWidgetLocalization({ langs }: LoadWidgetLocalizationParams) {
    const { freeLocalizationEndpoint } = this;

    try {
      const { data: links } = await axios.get<LoadWidgetLocalizationResponse>(
        `${freeLocalizationEndpoint}/api/v1/localizedText/getLinks`
      );

      const bundle: LoadWidgetLocalizationResponse['data'] = {};

      await Promise.all(
        Object.entries(links.data)
          .filter(([lang]) => langs.includes(lang.toLowerCase()))
          .map(async ([lang, nsMap]) => {
            const lngKey = lang.toLowerCase();
            bundle[lngKey] = {};
            await Promise.all(
              Object.entries(nsMap as Record<string, string>).map(async ([code, url]) => {
                const json = await axios
                  .get<Record<string, string>>(`${freeLocalizationEndpoint}${url}`)
                  .then((r) => r.data[code]);
                bundle[lngKey][code] = json;
              })
            );
          })
      );

      this.logger.Debug(`Loaded links`, links.data);
      this.logger.Debug(`Formed localization bundle`, bundle);
      return bundle;
    } catch (e) {
      this.logger.Error(`Failed to get localization tree`, e);
      return {};
    }
  }
}

export default FreeLocalizationService;
